import { Peergroup } from 'interfaces/peergroups'

export const DEFAULT_PROP_VALUE = 'All'

export const SLUGS = {
  peers: 'peers',
  everyone: 'everyone',
  'similar-income': 'similar-income',
  'similar-age': 'similar-age',
  'similar-location': 'similar-location',
  random: 'random',
}

export const SLUGS_ANALYTICS_MAP: Record<string, string> = {
  peers: 'your-peers',
  everyone: 'national-avg',
  'similar-income': 'similar-income',
  'similar-age': 'similar-age',
  'similar-location': 'similar-location',
  random: 'random',
}

export const SLUGS_TRACKER_MAP: Record<string, string> = {
  everyone: 'National Avg.',
  'similar-location': 'Your Area Avg.',
  'similar-income': 'Your Income Avg.',
  'similar-age': 'Your Age Avg.',
  random: 'Random Avg.',
}

export const EMPTY_PEER_GROUP: Peergroup = {
  id: 0,
  size: 0,
  age_range: null,
  area_type: null,
  creditscore_range: null,
  housing_type: null,
  income_range: null,
  location: null,
}

export const PEER_GROUP_COLORS = {
  member: '#404FA2',
  peers: '#E46565',
  others: '#9C546A',
}

export const MINIMAL_GROUP_SIZE = 5000
